import { render, staticRenderFns } from "./TinIndiumDialog.vue?vue&type=template&id=95210f52&scoped=true"
import script from "./TinIndiumDialog.vue?vue&type=script&lang=js"
export * from "./TinIndiumDialog.vue?vue&type=script&lang=js"
import style0 from "./TinIndiumDialog.vue?vue&type=style&index=0&id=95210f52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95210f52",
  null
  
)

export default component.exports